import { Record, List, fromJS } from 'immutable'
import { SUCCESS } from 'crom-api-constants'
import _ from 'lodash'

import { LOAD_GROUPS_REQUEST, GROUPS_LOADED } from './constants'
import { DELETE_GROUP_FROM_ENTITY_STACK } from '../../../../../../../../components/GroupEntity/constants'
import {
    CHANGE_ENTITY_STACK_GROUP_DATA,
    ADD_GROUP_TO_ENTITY_STACK,
    CHANGE_ENTITY_STACK_GROUP_MEMBERS,
} from '../../../../../GroupStack/constants'

const initialState = Record({
    loading: false,
    loaded: false,
    groups: List(),
})

export default function groupsReducer(state = initialState(), action = {}) {
    switch (action.type) {
        case LOAD_GROUPS_REQUEST: {
            return state.set('loading', true).set('loaded', false)
        }

        case `${LOAD_GROUPS_REQUEST}_${SUCCESS}`: {
            return state.set('loading', false).set('loaded', true)
        }
        case GROUPS_LOADED: {
            const groups = fromJS(_.get(action, 'data.groups', []))

            return state.set('groups', groups)
        }
        case CHANGE_ENTITY_STACK_GROUP_DATA: {
            const incomingData = _.get(action, 'data.data', {})
            const incomingDataGroupId = _.get(incomingData, 'id', null)

            const groups = state.get('groups')
            const indexOfGroupToChange = groups.findIndex((g) => g.get('id') === incomingDataGroupId)

            if (indexOfGroupToChange > -1) {
                return state.setIn(['groups', indexOfGroupToChange], fromJS(incomingData))
            }

            return state
        }
        case ADD_GROUP_TO_ENTITY_STACK: {
            const incomingGroup = _.get(action, 'data.data', {})

            if (_.isEmpty(incomingGroup)) return state

            const groups = state.get('groups').push(fromJS(incomingGroup))

            return state.set('groups', groups)
        }
        case DELETE_GROUP_FROM_ENTITY_STACK: {
            const idOfGroupToDelete = _.get(action, 'data.groupId', null)

            if (_.isNil(idOfGroupToDelete)) return state

            const groups = state
                .get('groups')
                .delete(state.get('groups').findIndex((g) => _.toString(g.get('id')) === idOfGroupToDelete))

            return state.set('groups', groups)
        }
        case CHANGE_ENTITY_STACK_GROUP_MEMBERS: {
            const idOfGroupToChange = _.get(action, 'data.groupId', null)
            const membersCount = _.get(action, 'data.membersCount', 0)

            if (_.isNil(idOfGroupToChange)) return state

            let groups = state.get('groups')
            const groupIndex = groups.findIndex((g) => _.toString(g.get('id')) === idOfGroupToChange)

            if (groupIndex < 0) return state

            let group = groups.get(groupIndex)
            group = group.set('members', membersCount)
            groups = groups.set(groupIndex, group)

            return state.set('groups', groups)
        }
        default:
            return state
    }
}
